/**
 * Hides all featured product images from a `shop the look` container
 * @param {HTMLElement} container - `shop the look` container
 */
function hideShopTheLookFeaturedImages(container) {
  const images = container.querySelectorAll('.js-shop-the-look-featured-image')
  images.forEach(image => {
    image.classList.add('shop-the-look__featured-image--hidden')
  });
}

/**
 * Change the featured product data from the block at the right of the `shop the look` block when a focus point is clicked
 *
 * @param {HTMLElement} target - Focus point element
 */
function focusPointClickEvent(target) {
  if (!target) {
    return
  }

  const container = target.closest('.js-shop-the-look-grid')

  hideShopTheLookFeaturedImages(container)
  container
    .querySelector(`.js-shop-the-look-featured-image[src="${target.dataset.image}"]`)
    .classList.remove('shop-the-look__featured-image--hidden')

  container
    .querySelector('.js-shop-the-look-featured-link')
    .setAttribute('href', target.dataset.link || '#')

  container.querySelector('.js-shop-the-look-featured-name').textContent = target.dataset.name || ''
  container.querySelector('.js-shop-the-look-featured-subtext').textContent = target.dataset.subtext || ''
}

/**
 * Change the featured product data from the block at the right of the `shop the look` block
 *
 * @param {HTMLElement} component - Slider component from slider.js
 */
function changeFeaturedData(component) {
  if (!component.currentPage) {
    return
  }

  const button = component.sliderItems[component.currentPage - 1].querySelector('.js-shop-the-look-focus-point')
  focusPointClickEvent(button)
}

window.addEventListener('click', (e) => {
  const target = e.target

  if (
    target.classList &&
    target.classList.contains('js-shop-the-look-focus-point')
  ) {
    focusPointClickEvent(target)
  }
})
